import { Body } from 'components/Typography';
import { cva, VariantProps } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';
import NumberFlow from '@number-flow/react';

import * as React from 'react';

const valueStyles = cva('', {
  variants: {
    size: {
      xsmall: 'text-[0.75rem] leading-[1.125rem] tracking-[0.4px]',
      small: 'font-normal text-[0.875rem] leading-[1.25rem] tracking-[0.4px]',
      medium: 'font-light text-[1.25rem] leading-[1.5rem]',
      large: 'font-normal text-[3rem] leading-[3.75rem]',
    },
    color: {
      gray: 'text-white-500',
      green: 'text-green',
      default: 'text-white',
    },
  },
  defaultVariants: {
    size: 'medium',
    color: 'default',
  },
});

const symbolStyles = cva('', {
  variants: {
    size: {
      xsmall: 'text-[0.625rem] leading-[0.75rem] pr-0.5',
      small: 'font-normal text-[0.625rem] leading-[0.75rem] pr-1',
      medium: 'font-normal text-[0.75rem] pr-1',
      large: 'font-normal text-[1.25rem] pr-1',
    },
    color: {
      gray: 'text-white-500',
      green: 'text-green',
      default: 'text-white',
    },
  },
  defaultVariants: {
    size: 'medium',
    color: 'default',
  },
});

export interface UsdValueProps extends VariantProps<typeof valueStyles> {
  value: number | string;
  className?: string;
  valueClassName?: string;
  symbolClassName?: string;
  formatter?: (value: number | string) => string;
  format?: Intl.NumberFormatOptions;
  spinTiming?: EffectTiming;
}

export const UsdValue = (props: UsdValueProps) => {
  const {
    size,
    color,
    value,
    symbolClassName,
    valueClassName,
    format = { minimumFractionDigits: 2, maximumFractionDigits: 2 },
    spinTiming,
  } = props;

  const symbolClassNames = twMerge(
    symbolStyles({ size, color }),
    symbolClassName
  );

  const valueClassNames = twMerge(valueStyles({ size, color }), valueClassName);

  return (
    <div className='inline-flex flex-row items-center'>
      <Body className={symbolClassNames}>$</Body>
      <Body className={valueClassNames}>
        <NumberFlow value={value} format={format} spinTiming={spinTiming} />
      </Body>
    </div>
  );
};
